import {
  Box,
  Button,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import SchoolIcon from '@mui/icons-material/School';
import PublicIcon from '@mui/icons-material/Public';
import GroupsIcon from '@mui/icons-material/Groups';
import FacebookIcon from '@mui/icons-material/Facebook';
import EmailIcon from '@mui/icons-material/Email';
import EditIcon from '@mui/icons-material/Edit';
import CakeIcon from '@mui/icons-material/Cake';
import InstagramIcon from '@mui/icons-material/Instagram';
import { DatePicker } from '@mui/x-date-pickers';
import XIcon from '@mui/icons-material/X';
import dayjs from 'dayjs';
import {
  createPersonalProfilerAction,
  getAllCompanyProprietorsAction,
  getAllLanguageAction,
  getAllQualificationAction,
  getPersonalProfilerAction,
  patchPersonalProfilerAction,
} from '../action';
import { toast, ToastContainer } from 'react-toastify';
import { isValidPhoneNumber, OperationType } from '../../../utils/settings';

function SocialDetails({ expanded = false }) {
  const [socialDetailsList, setSocialDetailsList] = useState([]);
  const [socialDetails, setSocialDetails] = useState({});
  const [ownersList, setOwnersList] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [proprietorsList, setProprietorsList] = useState([
    {
      firm_info: {},
      proprietors_list: [],
    },
  ]);
  const [qualificationOptions, setQualificationOptions] = useState([]);
  const [languageOptions, setLanguageOptions] = useState([]);
  const [proprietorsFlatList, setProprietorsFlatList] = useState([]);
  const [allowAdd, setAllowAdd] = useState(true);

  useEffect(() => {
    const flatProprietorsList = Array.from(
      new Set(
        proprietorsList.flatMap((item) =>
          item.proprietors_list.map((prop) => JSON.stringify(prop)),
        ),
      ),
    ).map((str) => JSON.parse(str));

    setProprietorsFlatList(flatProprietorsList);

    if (socialDetailsList.length > 0) {
      setAllowAdd(socialDetailsList?.length < flatProprietorsList.length);
    }
  }, [proprietorsList, socialDetailsList]);

  const getPersonalProfiler = async () => {
    const { data, error, message } = await getPersonalProfilerAction();

    if (!error) setSocialDetailsList(data.personal_details_info);
    else toast.error(message);
  };

  const getProprietorsList = async () => {
    const { data, error, message } = await getAllCompanyProprietorsAction();

    if (!error) setProprietorsList(data);
    else toast.error(message);
  };

  const getQualifications = async () => {
    const { data, error, message } = await getAllQualificationAction();

    if (!error) setQualificationOptions(data);
    else toast.error(message);
  };

  const getLanguages = async () => {
    const { data, error, message } = await getAllLanguageAction();

    if (!error) setLanguageOptions(data);
    else toast.error(message);
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setSocialDetails({});
    setOpen(false);
    setIsEditing(false);
  };

  useEffect(() => {
    if (expanded) {
      getProprietorsList();
      getQualifications();
      getLanguages();
      getPersonalProfiler();
    }
  }, [expanded]);

  const onFinish = async () => {
    if (!socialDetails.firmDetails) return toast.error('Please Select Firm');
    if (!socialDetails.ownerDetails) return toast.error('Please Select Owner');
    if (
      !socialDetails.whatsapp_number ||
      !isValidPhoneNumber(socialDetails.whatsapp_number)
    )
      return toast.error('Please enter a Valid whatsapp number');

    if (!socialDetails.date_of_birth)
      return toast.error('Please Select date of birth');
    if (!socialDetails.preferred_language)
      return toast.error('Please Select language');
    if (
      socialDetails.next_gen_participation === null ||
      socialDetails.next_gen_participation === undefined
    )
      return toast.error('Please Select next gen participation');

    const socialPayload = {
      owner_id: socialDetails.ownerDetails.id,
      firm_id: socialDetails.firmDetails.id,
      whatsapp_number: socialDetails.whatsapp_number,
      email_id: socialDetails.email_id,
      // qualification: socialDetails.qualification,
      marriage_anniversary: dayjs(socialDetails.marriage_anniversary).format(
        'YYYY-MM-DD',
      ),
      date_of_birth: dayjs(socialDetails.date_of_birth).format('YYYY-MM-DD'),
      preferred_language: socialDetails.preferred_language,
      next_gen_participation: socialDetails.next_gen_participation,
      social_media_urls: [
        {
          media_type: 'Facebook',
          url: socialDetails.facebook_url,
        },
      ],
    };

    const socialUrl = [];

    if (socialDetails?.facebook_url) {
      socialUrl.push({
        media_type: 'Facebook',
        url: socialDetails?.facebook_url,
      });
    }

    if (socialDetails?.instagram_url) {
      socialUrl.push({
        media_type: 'Instagram',
        url: socialDetails?.instagram_url,
      });
    }

    socialPayload.social_media_urls = socialUrl;

    const finalPayload = {
      personal_details_info: [socialPayload],
      family_details_info: [],
      recreation_details_info: [],
    };

    const { error, message } = await createPersonalProfilerAction(finalPayload);

    if (!error) {
      toast.success(message);
      handleClose();
      getPersonalProfiler();
    } else {
      toast.error(message);
    }
  };

  const onEdit = (item) => {
    const { firm_info, owner_info } = item;
    const payload = {
      firmDetails: firm_info,
      ownerDetails: {
        id: owner_info.owner_id,
        name: owner_info.name,
      },
      whatsapp_number: owner_info.whatsapp_number,
      email_id: owner_info.email_id,
      qualification: owner_info.qualification,
      marriage_anniversary: dayjs(owner_info.marriage_anniversary),
      date_of_birth: dayjs(owner_info.date_of_birth),
      preferred_language: owner_info.preferred_language,
      next_gen_participation:
        owner_info.next_gen_participation === 'True' ? true : false,
      id: owner_info.id,
      owner_id: owner_info.owner_id,
    };

    Array.isArray(owner_info?.social_media_urls) &&
      owner_info?.social_media_urls?.forEach((vv) => {
        if (vv.media_type === 'Facebook') {
          payload.facebook_url = vv.url;
        } else if (vv.media_type === 'Instagram') {
          payload.instagram_url = vv.url;
        }
      });

    const found = proprietorsList.find(
      (item) => item.firm_info.id === firm_info.id,
    );

    setOwnersList(found.proprietors_list);

    setSocialDetails(payload);
    setIsEditing(true);
    setOpen(true);
  };

  const onUpdate = async () => {
    const payload = {
      personal_details_info: [
        {
          owner_info: {
            id: socialDetails.id,
            whatsapp_number: socialDetails.whatsapp_number,
            email_id: socialDetails.email_id,
            qualification: socialDetails.qualification,
            marriage_anniversary: dayjs(
              socialDetails.marriage_anniversary,
            ).format('YYYY-MM-DD'),
            preferred_language: socialDetails.preferred_language,
            next_gen_participation: socialDetails.next_gen_participation,
            operation_type: OperationType['UPDATE'],
          },
          owner_id: socialDetails.owner_id,
          firm_id: socialDetails.firmDetails.id,
        },
      ],
    };

    const socialUrl = [];

    if (socialDetails?.facebook_url) {
      socialUrl.push({
        media_type: 'Facebook',
        url: socialDetails?.facebook_url,
      });
    }

    if (socialDetails?.instagram_url) {
      socialUrl.push({
        media_type: 'Instagram',
        url: socialDetails?.instagram_url,
      });
    }

    payload.personal_details_info[0].owner_info.social_media_urls = socialUrl;

    const { error, message } = await patchPersonalProfilerAction(payload);

    if (!error) {
      toast.success(message);
      handleClose();
      getPersonalProfiler();
    } else {
      toast.error(message);
    }
  };

  return (
    <div>
      <ToastContainer className="custom-toast-container" />
      {socialDetailsList.map((item) => (
        <CardContent>
          <Box
            sx={{
              borderWidth: 2,
              borderColor: '#F59C1E',
              borderStyle: 'solid',
              padding: 2,
              borderRadius: 2,
              position: 'relative',
            }}>
            <div
              className='editCtr'
              onClick={() => onEdit(item)}>
              <Tooltip title='Edit Details'>
                <EditIcon color='primary' />
              </Tooltip>
            </div>
            <div
              className='row-center'
              style={{
                justifyContent: 'space-between',
                marginBottom: 10,
              }}>
              <div className='row-center'>
                <Typography
                  fontSize={15}
                  fontWeight={'600'}
                  sx={{ marginRight: 1.5 }}>
                  {item.owner_info.name}
                </Typography>
                |
                <Typography
                  fontSize={15}
                  fontWeight={'600'}
                  sx={{ marginLeft: 1.5 }}>
                  {item.firm_info.name}
                </Typography>
              </div>

              <div>
                <Typography
                  fontSize={15}
                  fontWeight={'600'}
                  sx={{ marginLeft: 1 }}>
                  {item.owner_info.marriage_anniversary}
                </Typography>
              </div>
            </div>

            <div
              className='row-center'
              style={{
                justifyContent: 'space-between',
                marginBottom: 10,
              }}>
              <div className='row-center'>
                <div className='row-center'>
                  <WhatsAppIcon
                    color='success'
                    style={{
                      marginRight: 10,
                    }}
                  />
                  <Typography
                    fontSize={15}
                    sx={{ marginRight: 1.5 }}>
                    +91 {item.owner_info.whatsapp_number}
                  </Typography>
                </div>
                |
                <div className='row-center'>
                  <CakeIcon
                    style={{
                      marginRight: 10,
                      color: '#ff21b9',
                    }}
                    sx={{ marginLeft: 1.5 }}
                  />
                  <Typography
                    fontSize={15}
                    sx={{ marginRight: 1.5 }}>
                    {item.owner_info.date_of_birth}
                  </Typography>
                </div>
              </div>

              <div className='row-center'>
                <div className='row-center'>
                  <PublicIcon
                    color='success'
                    style={{
                      marginRight: 10,
                    }}
                  />
                  <Typography
                    fontSize={15}
                    sx={{ marginRight: 1.5 }}>
                    {item.owner_info.preferred_language}
                  </Typography>
                </div>
                |
                <div className='row-center'>
                  <GroupsIcon
                    color='info'
                    style={{
                      marginRight: 10,
                    }}
                    sx={{ marginLeft: 1.5 }}
                  />
                  <Typography fontSize={15}>
                    Next Gen Participating in Business -{' '}
                    {item.owner_info.next_gen_participation === 'True' ? 'Yes' : 'No'}
                  </Typography>
                </div>
              </div>
            </div>

            <div
              className='row-center'
              style={{
                justifyContent: 'space-between',
              }}>
              <div
                className='row-center'
                style={{
                  alignSelf: 'flex-start',
                }}>
                <EmailIcon
                  color='primary'
                  style={{
                    marginRight: 10,
                  }}
                />
                <Typography
                  fontSize={15}
                  sx={{ marginRight: 1 }}>
                  {item.owner_info.email_id}
                </Typography>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                }}>
                {item.owner_info.social_media_urls.map((vv) => {
                  if (vv.media_type === 'Facebook')
                    return (
                      <div
                        className='row-center profile-url'
                        onClick={() =>
                          window.open(vv.url, '_blank', 'noopener,noreferrer')
                        }>
                        <FacebookIcon
                          color='info'
                          style={{
                            marginRight: 10,
                          }}
                          sx={{ marginLeft: 1 }}
                        />
                        <Typography
                          fontSize={15}
                          style={{
                            maxWidth: '250px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}>
                          {vv.url}
                        </Typography>
                      </div>
                    );
                  else if (vv.media_type === 'Instagram')
                    return (
                      <div
                        className='row-center profile-url'
                        onClick={() =>
                          window.open(vv.url, '_blank', 'noopener,noreferrer')
                        }>
                        <InstagramIcon
                          style={{
                            marginRight: 10,
                            color: '#ff21b9',
                          }}
                          sx={{ marginLeft: 1 }}
                        />
                        <Typography
                          fontSize={15}
                          style={{
                            maxWidth: '250px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}>
                          {vv.url}
                        </Typography>
                      </div>
                    );
                })}
              </div>
            </div>
          </Box>
        </CardContent>
      ))}

      {allowAdd && (
        <div
          className='row-center'
          style={{
            justifyContent: 'flex-end',
          }}>
          <div>
            <Button
              onClick={() => {
                if (proprietorsFlatList.length === 0)
                  return toast.error('Please add owners and then fill details');
                handleOpen();
              }}
              sx={{ width: 150 }}
              variant='contained'>
              Add
            </Button>
          </div>
        </div>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'>
        <Box
          sx={{
            backgroundColor: 'white',
            width: '60%',
            overflowY: 'scroll',
            maxHeight: '95vh',
            borderRadius: '10px',
            padding: '20px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}>
          <CardContent>
            <div className='title-Ctr'>
              <Typography
                variant='h5'
                fontWeight={'600'}>
                {isEditing ? 'Update Personal Details' : 'Add Personal Details'}
              </Typography>
            </div>
            {/* Select Firm */}
            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}>
                  Select Firm
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <FormControl
                  fullWidth
                  margin='normal'>
                  <InputLabel id='demo-simple-select-label'>
                    Select Firm
                  </InputLabel>
                  <Select
                    disabled={isEditing}
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    value={socialDetails?.firmDetails?.id}
                    label='Select Firm'
                    onChange={(e) => {
                      const value = e.target.value;
                      const found = proprietorsList.find(
                        (item) => item.firm_info.id === value,
                      );

                      setSocialDetails((prev) => ({
                        ...prev,
                        firmDetails: found.firm_info,
                      }));
                      setOwnersList(found.proprietors_list);
                    }}>
                    {proprietorsList.map((item) => (
                      <MenuItem value={item.firm_info.id}>
                        {item.firm_info.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>

            {/* Select Owner */}
            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}>
                  Select Owner
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <FormControl
                  fullWidth
                  disabled={isEditing}
                  margin='normal'>
                  <InputLabel id='demo-simple-select-label'>
                    Select Owner
                  </InputLabel>
                  <Select
                    disabled={isEditing}
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    value={socialDetails?.ownerDetails?.id}
                    label='Select Owner'
                    onChange={(e) => {
                      const value = e.target.value;
                      const found = ownersList.find(
                        (item) => item.id === value,
                      );
                      setSocialDetails((prev) => ({
                        ...prev,
                        ownerDetails: found,
                      }));
                    }}>
                    {ownersList.map((item) => (
                      <MenuItem value={item.id}>{item.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>

            {/* Owner's WhatsApp Number */}
            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}>
                  Owner's WhatsApp Number
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <TextField
                  // disabled={!isBasicDetailEditing}
                  label='Number'
                  name='company_name'
                  value={socialDetails.whatsapp_number}
                  onChange={(e) => {
                    if (
                      /^\d*$/.test(e.target.value) &&
                      e.target.value.length <= 10
                    ) {
                      setSocialDetails((prev) => ({
                        ...prev,
                        whatsapp_number: e.target.value,
                      }));
                    }
                  }}
                  fullWidth
                  margin='normal'
                />
              </div>
            </div>

            {/* Personal Email ID */}
            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}>
                  Personal Email ID
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <TextField
                  // disabled={!isBasicDetailEditing}
                  label='Email ID'
                  name='company_name'
                  value={socialDetails.email_id}
                  onChange={(e) => {
                    setSocialDetails((prev) => ({
                      ...prev,
                      email_id: e.target.value,
                    }));
                  }}
                  fullWidth
                  margin='normal'
                />
              </div>
            </div>

            {/* Qualification */}
            {/* <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}>
                  Qualification
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <FormControl
                  fullWidth
                  margin='normal'>
                  <InputLabel id='demo-simple-select-label'>
                    Select Qualification
                  </InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    value={socialDetails.qualification}
                    label='Select Qualification'
                    onChange={(e) => {
                      const value = e.target.value;
                      setSocialDetails((prev) => ({
                        ...prev,
                        qualification: value,
                      }));
                    }}>
                    {qualificationOptions.map((item) => (
                      <MenuItem value={item}>{item}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div> */}

            {/* Personal D.O.B */}
            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}>
                  Date Of Birth
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <DatePicker
                  label='Select Date'
                  fullWidth
                  value={
                    socialDetails?.date_of_birth &&
                    dayjs(socialDetails?.date_of_birth)
                  }
                  maxDate={dayjs()}
                  onChange={(e) => {
                    setSocialDetails((prev) => ({
                      ...prev,
                      date_of_birth: e,
                    }));
                  }}
                  sx={{
                    marginTop: '16px',
                    marginBottom: '8px',
                    width: '100%',
                  }}
                />
              </div>
            </div>

            {/* Marriage Anniversary */}
            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}>
                  Marriage Anniversary
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <DatePicker
                  label='Select Date'
                  fullWidth
                  value={
                    socialDetails?.marriage_anniversary &&
                    dayjs(socialDetails?.marriage_anniversary)
                  }
                  maxDate={dayjs()}
                  onChange={(e) => {
                    setSocialDetails((prev) => ({
                      ...prev,
                      marriage_anniversary: e,
                    }));
                  }}
                  sx={{
                    marginTop: '16px',
                    marginBottom: '8px',
                    width: '100%',
                  }}
                />
              </div>
            </div>

            {/* Prefered Language */}
            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}>
                  Prefered Language
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <FormControl
                  fullWidth
                  margin='normal'>
                  <InputLabel id='demo-simple-select-label'>
                    Select Preference
                  </InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    value={socialDetails.preferred_language}
                    label='Select Preference'
                    onChange={(e) => {
                      const value = e.target.value;
                      setSocialDetails((prev) => ({
                        ...prev,
                        preferred_language: value,
                      }));
                    }}>
                    {languageOptions.map((item) => (
                      <MenuItem value={item}>{item}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>

            {/* Likelihood of next generation participating in your Business */}
            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}>
                  Likelihood of next generation participating in your Business
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <FormControl
                  fullWidth
                  margin='normal'>
                  <InputLabel id='demo-simple-select-label'>
                    Select Preference
                  </InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    value={socialDetails.next_gen_participation}
                    label='Select Preference'
                    onChange={(e) => {
                      const value = e.target.value;
                      setSocialDetails((prev) => ({
                        ...prev,
                        next_gen_participation: value,
                      }));
                    }}>
                    <MenuItem value={true}>Yes</MenuItem>
                    <MenuItem value={false}>No</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>

            {/* FaceBook Profile URL */}
            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}>
                  FaceBook Profile URL
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <TextField
                  label='Enter profile Url'
                  name='profile_url'
                  value={socialDetails.facebook_url}
                  onChange={(e) => {
                    setSocialDetails((prev) => ({
                      ...prev,
                      facebook_url: e.target.value,
                    }));
                  }}
                  fullWidth
                  margin='normal'
                />
              </div>
            </div>

            {/* Instagram Profile URL */}
            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}>
                  Instagram Profile URL
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <TextField
                  label='Enter profile Url'
                  name='profile_url'
                  value={socialDetails.instagram_url}
                  onChange={(e) => {
                    setSocialDetails((prev) => ({
                      ...prev,
                      instagram_url: e.target.value,
                    }));
                  }}
                  fullWidth
                  margin='normal'
                />
              </div>
            </div>

            <div
              className='row-center'
              style={{
                justifyContent: 'flex-end',
              }}>
              <div>
                {/*  */}
                <Button
                  onClick={handleClose}
                  sx={{ width: 150, marginTop: 2, marginRight: 2 }}
                  variant='contained'
                  color='error'>
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    if (isEditing) onUpdate();
                    else onFinish();
                  }}
                  sx={{ width: 150, marginTop: 2 }}
                  variant='contained'>
                  Save
                </Button>
              </div>
            </div>
          </CardContent>
        </Box>
      </Modal>
    </div>
  );
}

export default SocialDetails;
